"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInline = void 0;
var react_1 = __importStar(require("react"));
var react_popper_1 = require("react-popper");
var styles_1 = require("../../styles");
var react_2 = require("../../util/react");
var Button_1 = require("../Button");
var Icon_1 = require("../Icon");
var Select_1 = require("../Select/Select");
var Text_1 = require("../Text");
/**
 * @deprecated
 *
 * This component has been deprecated, please use Combobox instead
 *
 * Before:
 *
 * `<SelectInline />`
 *
 * After:
 *
 * `<Combobox inline />`
 *
 * @deprecatedSince 1.0.0-beta.65
 */
function SelectInline(props) {
    var value = props.value, inputRef = props.inputRef, onChange = props.onChange, buttonProps = props.buttonProps, popperProps = props.popperProps, itemToString = props.itemToString, defaultButtonText = props.defaultButtonText, rest = __rest(props, ["value", "inputRef", "onChange", "buttonProps", "popperProps", "itemToString", "defaultButtonText"]);
    var _a = buttonProps || {}, innerRef = _a.innerRef, buttonRest = __rest(_a, ["innerRef"]);
    var _b = styles_1.useStyles(createStyles), classes = _b.classes, css = _b.css;
    var _c = react_1.useState(), selectInputRef = _c[0], setSelectInputRef = _c[1];
    var _d = react_1.useState(), anchorRef = _d[0], setAnchorRef = _d[1];
    var _e = react_1.useState(), popperRef = _e[0], setPopperRef = _e[1];
    var _f = react_1.useState(false), open = _f[0], setOpen = _f[1];
    var _g = react_popper_1.usePopper(anchorRef, popperRef, popperProps), popperStyle = _g.styles.popper, placement = _g.attributes.placement;
    react_1.useEffect(function () {
        if (open && selectInputRef) {
            selectInputRef.focus();
        }
    }, [open, selectInputRef]);
    var handleButtonClick = function () { return setOpen(function (state) { return !state; }); };
    var handleChange = function () { return setOpen(false); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.Button, __assign({ innerRef: react_2.composeRefs(setAnchorRef, innerRef), onClick: handleButtonClick, skin: 'ghost', kind: 'normal', size: 'small' }, buttonRest),
            react_1.default.createElement(Text_1.Text, null, itemToString(value) || defaultButtonText),
            react_1.default.createElement(Icon_1.Icon, { style: { marginLeft: '0.5rem' }, icon: open ? 'angleUp' : 'angleDown' })),
        open && (react_1.default.createElement("div", { ref: setPopperRef, className: css(classes.box, popperStyle), "data-placement": placement },
            react_1.default.createElement(Select_1.Select, __assign({ inputRef: react_2.composeRefs(setSelectInputRef, inputRef), itemToString: itemToString, onChange: react_2.composeHandlers(handleChange, onChange), isOpen: true, icon: null }, rest))))));
}
exports.SelectInline = SelectInline;
var createStyles = function (theme) { return ({
    box: {
        zIndex: theme.zIndex.popper,
        border: "1px solid " + theme.pallete.divider,
        boxShadow: theme.shadows.outer['40'],
        backgroundColor: theme.pallete.surface.main,
        '& [role="combobox"] > div > div': {
            margin: '0.5rem',
        },
        '& ul > li:first-of-type': {
            marginTop: '0.5rem',
            borderTop: "1px solid " + theme.pallete.divider,
        },
        '& ul': {
            width: '100%',
            position: 'static',
            top: 'initial',
            left: 'initial',
            transform: 'none',
            boxShadow: 'none',
            border: 'none',
            borderRadius: 0,
        },
    },
}); };
//# sourceMappingURL=SelectInline.js.map